import { AUTH_ERROR_MESSAGE } from "./useInitalisedConfig";
import { replaceBracedComponents } from "./replaceBracedComponents";
import { configMerge } from "./utils";
export const loadRemote = async (tempConfig) => {
    const { remote, remoteHeaders: headers } = tempConfig;
    if (!remote)
        return Promise.resolve({});
    const remoteConfigs = await Promise.all([remote]
        .flat()
        .map((url) => replaceBracedComponents(url, tempConfig))
        .map(async (url) => {
        const response = await fetch(url, headers ? { headers } : undefined);
        if (response.status === 401 || response.status === 403)
            throw new Error(AUTH_ERROR_MESSAGE);
        return response.json();
    }));
    return configMerge(...remoteConfigs);
};
